import { orange } from '@mui/material/colors';

const styles = theme => ({
  expansionBlock: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  innerExpansionSummary: {
    paddingLeft: theme.spacing(0.5),
    // paddingRight: theme.spacing(0.5),
  },
  expansionDetails: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  formRow: {
    display: 'flex',
  },
  warning: {
    backgroundColor: orange[300],
  },
  withTopSpacer: {
    marginTop: theme.spacing(1),
  },
});

export default styles;
